import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Informacoes.module.css';

export default function Informacoes() {
    const navigate = useNavigate();
    const nome = sessionStorage.getItem('nomeUsuario') || '';
    const primeiroNome = nome.split(' ')[0] || '';

    return (
        <div className={styles.wrap}>

            <div className={styles.iconWrap}>
                <span className={styles.icon}>📋</span>
            </div>

            <h1 className={styles.title}>
                Você já possui uma proposta em andamento!
            </h1>

            <p className={styles.message}>
                {primeiroNome && <><strong>{primeiroNome}</strong>, entre</>}
                {!primeiroNome && <>Entre</>}{' '}
                em contato com o consultor que iniciou seu atendimento, pois não é possível
                criar uma nova proposta no momento.
            </p>

        </div>
    );
}